import gql from "graphql-tag";

export const CANCEL_SUBSCRIPTION_MUTATION = gql`
  mutation CancelSubscription($input: CancellationInput!) {
    cancelSubscription(input: $input) {
      id
      amount
      status
      nextPaymentDate
      cardNumber
      cardBrand
      cardExpirationDate
      productName
      installments
      provider
      endAt
      remainingDays
    }
  }
`;
